import React, { useState, useEffect } from 'react';
import { Surface, StyledImagePlaceholder, Stack, SmartContainer } from '../../styles/Containers';
import { StyledB, StyledP } from '../../styles/StyledHTML';

import { convertCentsToPrice } from '../../services/Stripe';
import { loadProduct } from './redux/networkproduct.actions';

export const getLowestPrice = (product) => {
    if (!product.prices) return null;
    let price;
    product.prices.map(item => {
        if (!price) price = item;
        if (item.price < price) price = item;

    })
    return price;
}


export const NetworkProductCard = ({ product, onClick, }) => {

    const price = getLowestPrice(product);

    return (
        <Surface width="100%" clickable onClick={() => onClick(product)}>
            <Stack>
                {product.image && (<div>{product.image}</div>)}
                {!product.image && (<StyledImagePlaceholder minHeight="200px" />)}
                <StyledB>{product.name}</StyledB>
                {price && (<StyledP light>${convertCentsToPrice(price.price)}</StyledP>)}
            </Stack>
        </Surface>
    )
}


export const SmartNetworkProductCard = ({ id }) => {
    const [item, setItem] = useState(null);
    const [loading, setLoading] = useState(true);


    const load = async (id) => {
        if (!id) return;
        setLoading(true);
        const res = await loadProduct(id);
        if (res.status === 'success') {
            setItem(res.data);
            setLoading(false);
        } else {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (item && item.id === id) return;
        load(id); // Load the Guide
    }, [id])

    return (
        <SmartContainer thinking={loading} width="100%">
            {item && (<StyledP>{item?.name}</StyledP>)}
        </SmartContainer>
    )
}
/*
import React, { useState, useEffect } from 'react';
import { SmartContainer } from '../../../styles/Containers';
import { StyledP } from '../../../styles/StyledHTML';
import { loadMeditation } from './redux/meditations.actions';

export const MeditationCard = ({ id }) => {

    const [meditation, setMeditation] = useState(null);
    const [loading, setLoading] = useState(true);


    const load = async (id) => {
        if (!id) return;
        setLoading(true);
        const res = await loadMeditation(id);
        if (res.status === 'success') {
            setMeditation(res.data);
            setLoading(false);
        } else {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (meditation && meditation.id === id) return;
        load(id); // Load the Guide
    }, [id])

    return (
        <SmartContainer thinking={loading} width="100%">
            {meditation && (<StyledP>{meditation?.name}</StyledP>)}
        </SmartContainer>
    )
}*/